<template>
  <div id="app">
    <Header></Header>
    <div style="position: relative;min-height: 300px; min-width: 1263px;">
      <router-view></router-view>
    </div>
    <Footer></Footer>
    <GoTop v-show="false"></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import './assets/css/base.css';

.head{
 
}
.el-carousel__container {
  width: 100%;
  height: 100% !important;
}
article, aside, blockquote, body, button, dd, details, div, dl, dt, fieldset, figcaption, figure, footer, form, h1, h2, h3, h4, h5, h6, header, hgroup, hr, input, legend, li, menu, nav, ol, p, section, td, textarea, th, ul {
    margin: 0;
    padding: 0;
}

</style>



// WEBPACK FOOTER //
// src/App.vue